import {
  doGet,
  doPost,
} from '@/http';
import axios from 'axios';

const actions = {
  getOwnedBooks: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-owned-books',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  getStartedBooks: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-started-books',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  getUnownedBooks: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-unowned-books',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  getBook: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/get-book/${ id }`,
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      });
    });
  },
  setBookPageInformation: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/set-book-page-information',
        data: requestData,
        method: 'POST',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
};

export default {
  namespaced: true,
  actions,
};
